// @flow

import {
  HomeIcon,
  AnalyticsIcon,
  FilterMenuIcon,
  ThumbsUpIcon,
  SetupIcon,
  CartIcon,
  CartNotiIcon,
  InsightIcon,
  SettingsIcon,
  ABTestingIcon,
  SettingsMinorIcon,
  PrimaryIcon,
  SearchIcon,
  AIIcon,
  ArchiveIcon,
  AppIcon
} from 'src/components/containers/common/icon';
import { CustomersMinor } from '@shopify/polaris-icons';
import { routes } from 'src/routes';
import { OLD_SWATCH_LIST } from 'src/constants/general-swatch';

export const EXTRA_ACTION = {
  CLEAR_CACHE_MANAGE_TEMPLATE: 'CLEAR_CACHE_MANAGE_TEMPLATE'
};

export const getMenuLeft = (i18n, conditions = {}, tenantApp) => {
  const {
    hideAISearch = false,
    usingNewTheme = false,
    hidePredictiveBundle,
    isHideBackInStockMenu,
    hasShopifyIntegration
  } = conditions;

  if (hasShopifyIntegration) {
    return getMenuLeftTurbo(i18n, conditions, tenantApp);
  }

  return [
    {
      title: i18n.translate('AdminHTML.MainMenuV2.home'),
      id: 'menu-home',
      icon: HomeIcon,
      routeTo: routes.dashboard.view(),
      isNew: false
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.filters'),
      id: 'menu-filters',
      icon: FilterMenuIcon,
      isNew: false,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.setup'),
          icon: SetupIcon,
          id: 'menu-filters-setup',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.filterTrees'),
              isNew: false,
              id: 'menu-filters-filter-trees',
              routeTo: routes.filterTree.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.merchandising'),
              isNew: false,
              id: 'menu-filters-merchandising',
              routeTo: `${routes.merchandising.view()}?panelID=collection`
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.filterLayout'),
              isNew: false,
              id: 'menu-filters-layout',
              isHide: !usingNewTheme,
              routeTo: routes.filterLayout.view()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.displaySettings'),
              isNew: false,
              id: 'menu-filters-display-settings',
              routeTo: routes.filterSettings.view()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.insights'),
          icon: InsightIcon,
          id: 'menu-filters-insights',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.analytics'),
              isNew: false,
              id: 'menu-analytics-collection',
              routeTo: routes.analytics.overviewCollection()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.tools'),
          icon: SettingsMinorIcon,
          id: 'menu-filters-tools',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.mergeValues'),
              isNew: false,
              id: 'menu-filters-merge-values',
              routeTo: routes.mergeValues.view()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.customRangeSliders'),
              isNew: false,
              id: 'menu-filters-custom-range-sliders',
              routeTo: routes.customRangeSlider.view()
            },
            ...(!hasShopifyIntegration || OLD_SWATCH_LIST.includes(tenantApp.tenantId)
              ? [
                {
                  title: i18n.translate('AdminHTML.MainMenuV2.swatches'),
                  isNew: false,
                  isHide: !usingNewTheme,
                  id: 'menu-filters-swatch-settings',
                  routeTo: routes.swatchSettings.view()
                }
              ]
              : [])
          ]
        }
      ]
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.search'),
      id: 'menu-search',
      icon: SearchIcon,
      isNew: false,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.setup'),
          icon: SetupIcon,
          id: 'menu-search-setup',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.searchControl'),
              isNew: false,
              id: 'menu-search-search-control',
              routeTo: routes.searchControl.view(),
              isHide: hideAISearch
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.standardSearch'),
              isNew: false,
              id: 'menu-search-standard-search',
              routeTo: routes.relevanceSettings.view()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.AIPowerSearch'),
              badge: 'ai',
              isNew: false,
              id: 'menu-search-ai-power-search',
              routeTo: routes.generalAdvancedSearch.view()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.merchandising'),
              isNew: false,
              id: 'menu-search-merchandising',
              routeTo: `${routes.merchandising.view()}?panelID=search`
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.insights'),
          icon: InsightIcon,
          id: 'menu-search-insights',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.analytics'),
              isNew: false,
              id: 'menu-analytics-search',
              routeTo: routes.analytics.overviewSearch()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.tools'),
          icon: SettingsMinorIcon,
          id: 'menu-search-tools',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.testYourSearch'),
              isNew: false,
              isHide: hideAISearch,
              id: 'menu-search-test-your-search',
              routeTo: routes.testYourSearch.view()
            }
          ]
        }
      ]
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.recommendations'),
      id: 'menu-recommendation',
      isNew: false,
      icon: ThumbsUpIcon,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.setup'),
          icon: SetupIcon,
          id: 'menu-recommendation-setup',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.recommendationManageWidgets'),
              isNew: false,
              id: 'menu-recommendation-widget',
              routeTo: routes.recommendationWidgets.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.predictiveBundle'),
              isNew: true,
              id: 'menu-predictive-bundle',
              isHide: hidePredictiveBundle,
              routeTo: routes.predictiveBundle.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.postPurchase'),
              isBeta: true,
              id: 'menu-post-purchase',
              routeTo: routes.postPurchase.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.recommendationGeneralSettings'),
              isNew: false,
              id: 'menu-recommendation-general-settings',
              routeTo: routes.recommendationGeneralSettings.settings()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.insights'),
          icon: InsightIcon,
          id: 'menu-recommendation-insights',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.analytics'),
              isNew: false,
              id: 'menu-analytics-recommendation',
              routeTo: routes.analytics.recommendationOverview()
            }
          ]
        }
      ]
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.personalization'),
      id: 'menu-personalization',
      icon: CustomersMinor,
      routeTo: routes.personalization.view(),
      isNew: false
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.preOrder'),
      id: 'menu-pre-order',
      icon: CartIcon,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.preOrder'),
          icon: SetupIcon,
          id: 'menu-pre-order-common',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.preOrderCampaign'),
              isNew: false,
              id: 'menu-pre-order-campaign',
              routeTo: routes.preOrder.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.notificationSetting'),
              id: 'menu-pre-order-notification-settings',
              routeTo: routes.preOrder.notifySetting()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.analytics'),
              isNew: false,
              id: 'menu-analytics-pre-order',
              routeTo: routes.analytics.preOrders()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.backInStock'),
          icon: CartNotiIcon,
          id: 'menu-back-in-stock',
          isHide: isHideBackInStockMenu,
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.backInStockSettings'),
              isNew: false,
              id: 'menu-back-in-stock-settings',
              routeTo: routes.backInStock.settings()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.backInStockSubscription'),
              isNew: false,
              id: 'menu-back-in-stock-subscriptions',
              routeTo: routes.backInStock.subscription()
            }
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.tools'),
          icon: SettingsIcon,
          id: 'menu-revenue-tool',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.domainSetting'),
              id: 'menu-revenue-tool-domain-settings',
              routeTo: routes.tools.domainSetting()
            }
          ]
        }
      ]
    }
  ];
};


const getMenuLeftTurbo = (i18n, conditions = {}) => {
  const {
    hideAISearch = false,
    usingNewTheme = false,
    hidePredictiveBundle,
  } = conditions;

  return [
    {
      id: 'menu-home',
      icon: HomeIcon,
      routeTo: routes.dashboard.view(),
      isNew: false
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.filters'),
      id: 'menu-filters',
      icon: FilterMenuIcon,
      isNew: false,
      isMenuOneLevel: true,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.filterTrees'),
          isNew: false,
          id: 'menu-filters-filter-trees',
          routeTo: routes.filterTree.list()
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.filterLayout'),
          isNew: false,
          id: 'menu-filters-layout',
          isHide: !usingNewTheme,
          routeTo: routes.filterLayout.view()
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.displaySettings'),
          isNew: false,
          id: 'menu-filters-display-settings',
          routeTo: routes.filterSettings.view()
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.mergeValues'),
          isNew: false,
          id: 'menu-filters-merge-values',
          routeTo: routes.mergeValues.view()
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.customRangeSliders'),
          isNew: false,
          id: 'menu-filters-custom-range-sliders',
          routeTo: routes.customRangeSlider.view()
        },
      ]
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.search'),
      id: 'menu-search',
      icon: SearchIcon,
      isNew: false,
      isMenuOneLevel: true,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.engineControl'),
          isNew: false,
          id: 'menu-search-search-control',
          routeTo: routes.searchControl.view(),
          isHide: hideAISearch
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.testSearch'),
          isNew: false,
          isHide: hideAISearch,
          id: 'menu-search-test-your-search',
          routeTo: routes.testYourSearch.view()
        }
      ]
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.merchandising'),
      id: 'menu-merchandising',
      isNew: false,
      isNewStyle: true,
      icon: ArchiveIcon,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.merchandising'),
          id: 'menu-merchandising-merchandising',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.searchRules'),
              isNew: false,
              id: 'menu-merchandising-search-rules',
              routeTo: `${routes.merchandising.search()}`
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.collectionRules'),
              isNew: false,
              id: 'menu-merchandising-collection-rules',
              routeTo: `${routes.merchandising.collection()}`
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.ABTesting'),
              isNew: false,
              id: 'menu-merchandising-ab-testing',
              routeTo: `${routes.abTesting.list()}`
            },
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.recommendations'),
          id: 'menu-merchandising-recommendations',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.widgets'),
              isNew: false,
              id: 'menu-merchandising-recommendation-widget',
              routeTo: routes.recommendationWidgets.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.predictiveBundle'),
              isNew: false,
              id: 'menu-merchandising-predictive-bundle',
              isHide: hidePredictiveBundle,
              routeTo: routes.predictiveBundle.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.postPurchase'),
              isBeta: true,
              id: 'menu-post-purchase',
              routeTo: routes.postPurchase.list()
            },
          ]
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.Common.sellMore'),
          id: 'menu-sell-more',
          subMenu: [
            {
              title: i18n.translate('AdminHTML.MainMenuV2.preOrder2'),
              isNew: false,
              id: 'menu-merchandising-pre-order-campaign',
              routeTo: routes.preOrder.list()
            },
            {
              title: i18n.translate('AdminHTML.MainMenuV2.backInStock'),
              isNew: false,
              id: 'menu-merchandising-back-in-stock-settings',
              routeTo: routes.backInStock.settings()
            },
          ]
        }
      ]
    },
    {
      title: i18n.translate('AdminHTML.MainMenuV2.personalization'),
      id: 'menu-personalization',
      icon: CustomersMinor,
      routeTo: routes.personalization.view(),
      isNew: false
    },
  ];
}

export const getMenuRight = (i18n, conditions = {}) => {
  const { hasShopifyIntegration, enabledRecommendationType, enableAISearch } = conditions;

  const menuAnalytics = hasShopifyIntegration ? {
    id: 'menu-analytics',
    icon: AnalyticsIcon,
    isNew: false,
    title: hasShopifyIntegration ? i18n.translate('AdminHTML.MainMenuV2.analytics') : '',
    isMenuOneLevel: true,
    children: [
      {
        title: i18n.translate('AdminHTML.MainMenuV2.revenueImpact'),
        isNew: false,
        id: 'menu-analytics-performance-revenue',
        routeTo: routes.analytics.appImpact()
      },
      {
        title: i18n.translate('AdminHTML.MainMenuV2.filters'),
        isNew: false,
        id: 'menu-analytics-collection',
        routeTo: routes.analytics.overviewCollection()
      },
      {
        title: i18n.translate(
          `AdminHTML.MainMenuV2.${enableAISearch ? 'aiSearch' : 'search'}`
        ),
        isNew: false,
        id: 'menu-analytics-search',
        routeTo: routes.analytics.overviewSearch()
      },
      {
        title: i18n.translate(
          `AdminHTML.MainMenuV2.${enabledRecommendationType ? 'aiRecommendation' : 'recommendation'
          }`
        ),
        isNew: false,
        id: 'menu-analytics-recommendation',
        routeTo: routes.analytics.recommendationOverview()
      },
      {
        title: i18n.translate('AdminHTML.MainMenuV2.preOrderAnalytics'),
        isNew: false,
        id: 'menu-analytics-pre-order',
        routeTo: routes.analytics.preOrders()
      },
    ]
  } : {
    id: 'menu-analytics',
    icon: AnalyticsIcon,
    isNew: false,
    title: hasShopifyIntegration ? i18n.translate('AdminHTML.MainMenuV2.analytics') : '',
    children: [
      {
        title: i18n.translate(hasShopifyIntegration ? 'AdminHTML.MainMenuV2.Common.analytics' : 'AdminHTML.MainMenuV2.Common.insights'),
        icon: InsightIcon,
        id: 'menu-performance-insights',
        subMenu: [
          {
            title: i18n.translate('AdminHTML.MainMenuV2.revenueImpact'),
            isNew: false,
            id: 'menu-analytics-performance-revenue',
            routeTo: routes.analytics.appImpact()
          },
          {
            title: i18n.translate(
              `AdminHTML.MainMenuV2.${enableAISearch ? 'aiSearch' : 'search'}`
            ),
            isNew: false,
            id: 'menu-analytics-search',
            routeTo: routes.analytics.overviewSearch()
          },
          {
            title: i18n.translate('AdminHTML.MainMenuV2.filters'),
            isNew: false,
            id: 'menu-analytics-collection',
            routeTo: routes.analytics.overviewCollection()
          },
          {
            title: i18n.translate(
              `AdminHTML.MainMenuV2.${enabledRecommendationType ? 'aiRecommendation' : 'recommendation'
              }`
            ),
            isNew: false,
            id: 'menu-analytics-recommendation',
            routeTo: routes.analytics.recommendationOverview()
          },
          {
            title: i18n.translate('AdminHTML.MainMenuV2.preOrderAnalytics'),
            isNew: false,
            id: 'menu-analytics-pre-order',
            routeTo: routes.analytics.preOrders()
          },
          {
            title: i18n.translate('AdminHTML.MainMenuV2.backInStockSubscription'),
            isNew: false,
            id: 'menu-back-in-stock-subscriptions',
            routeTo: routes.backInStock.subscription()
          }
        ]
      },
      {
        title: i18n.translate('AdminHTML.MainMenuV2.Common.tools'),
        icon: SettingsMinorIcon,
        id: 'menu-performance-tools',
        subMenu: [
          {
            title: i18n.translate('AdminHTML.MainMenuV2.analyticSettings'),
            isNew: false,
            id: 'menu-analytics-settings',
            routeTo: routes.analytics.settings()
          }
        ]
      }
    ]
  };

  const result = [
    ...(!hasShopifyIntegration ? [{
      title: '',
      id: 'menu-ai',
      icon: AIIcon,
      routeTo: routes.aiPowered.view()
    },
    {
      id: 'menu-merchandising-ab-testing',
      icon: ABTestingIcon,
      routeTo: routes.abTesting.list()
    }] : []),

    menuAnalytics,

    {
      id: 'menu-integration',
      icon: hasShopifyIntegration ? AppIcon : PrimaryIcon,
      title: hasShopifyIntegration ? i18n.translate('AdminHTML.MainMenuV2.integration') : "",
      isMenuOneLevel: true,
      children: [
        {
          title: i18n.translate('AdminHTML.MainMenuV2.shopifyIntegration'),
          isNew: false,
          id: 'menu-integration-shopify-integration',
          routeTo: hasShopifyIntegration
            ? routes.shopifyIntegration.view()
            : routes.themeSetup.view()
        },
        {
          title: i18n.translate('AdminHTML.MainMenuV2.thirdPartyIntegration'),
          isNew: false,
          id: 'menu-integration-third-party',
          routeTo: routes.integration.view()
        }
        // {
        //   title: i18n.translate('AdminHTML.MainMenuV2.Common.layout'),
        //   icon: ThemeIcon,
        //   id: 'menu-integration-layout',
        //   subMenu: [
        //     {
        //       title: i18n.translate('AdminHTML.MainMenuV2.templateLibrary'),
        //       isNew: false,
        //       id: 'menu-manage-shopify-integration',
        //       routeTo: routes.shopifyIntegration.templateLibrary(),
        //       extraAction: EXTRA_ACTION.CLEAR_CACHE_MANAGE_TEMPLATE
        //     }
        //   ]
        // }
      ]
    },
    {
      id: 'menu-settings',
      title: hasShopifyIntegration ? i18n.translate('AdminHTML.MainMenuV2.settings') : "",
      icon: SettingsIcon,
      routeTo: routes.settings.view()
    }
  ];

  return result;
};
